import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
    faAt,
    faLink,
    faInfo,
    faTimes,
    faFilter,
    faPrint,
    faHeart,
    faTasks,
    faComment,
    faEnvelope,
    faBullseye,
    faMobileAlt,
    faBriefcase,
    faCodeBranch,
    faDollarSign,
    faAddressBook,
    faNetworkWired,
    faGraduationCap,
    faLocationArrow,
    faSearchLocation
} from '@fortawesome/free-solid-svg-icons'

import { fab, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

library.add(
    fab,
    faAt,
    faLink,
    faInfo,
    faTimes,
    faFilter,
    faPrint,
    faHeart,
    faTasks,
    faComment,
    faWhatsapp,
    faEnvelope,
    faBullseye,
    faMobileAlt,
    faBriefcase,
    faCodeBranch,
    faDollarSign,
    faAddressBook,
    faNetworkWired,
    faGraduationCap,
    faLocationArrow,
    faSearchLocation
)

export default FontAwesomeIcon
